import { Avatar, Dropdown, DropdownMenuItem } from '@shared-ui/components'
import { MenuItem } from '@shared-ui/components/Menu'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AccountCircle, InputIcon } from 'shared/assets/icons'
import { useLogout } from 'shared/lib'

export const UserProfileMenu = ({ userImg }: { userImg: string }) => {
    const { t } = useTranslation(['common'])
    const [isOpen, setIsOpen] = useState(false)

    const [logout] = useLogout()
    const navigate = useNavigate()

    return (
        <Dropdown
            classNames="mr-6"
            open={isOpen}
            onOpenChange={() => setIsOpen(!isOpen)}
            trigger={
                <span
                    className="outline-none"
                    role="button"
                    tabIndex={0}
                    onClick={() => setIsOpen(true)}
                >
                    <Avatar size="sm" imgSrc={userImg} />
                </span>
            }
        >
            <DropdownMenuItem onSelect={() => setIsOpen(!isOpen)}>
                <MenuItem
                    id="item-1"
                    handleActive={() => {}}
                    className="gap-2"
                    labelClassName={'!text-dropdown-hover'}
                    itemIcon={<AccountCircle />}
                    handleItemClick={() => {
                        navigate('/korisnicki-profil')
                    }}
                    label={t('shared:layout.user-profile')}
                />
            </DropdownMenuItem>
            <DropdownMenuItem
                onSelect={() => {
                    logout()
                }}
            >
                <MenuItem
                    id="item-2"
                    handleActive={() => {}}
                    className="gap-2"
                    labelClassName={'text-background-error'}
                    itemIcon={<InputIcon />}
                    handleItemClick={() => {
                        logout()
                    }}
                    label={t('shared:layout.logout')}
                />
            </DropdownMenuItem>
        </Dropdown>
    )
}
